import Vue from "vue";
import {
  Button,
  Form,
  Message,
  MessageBox,
  Breadcrumb,
  BreadcrumbItem,
  FormItem,
  Input,
  Row,
  Col,
  Pagination,
  Menu,
  Submenu,
  MenuItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Card,
  Table,
  TableColumn,
  Dialog,
  Select,
  Option,
  DatePicker,
  TimeSelect,
  TimePicker,
  Tree,
  Tabs,
  TabPane,
  DescriptionsItem,
  Descriptions,
  Tag,
  Badge,
  Cascader,
  Tooltip,
  RadioGroup,
  RadioButton,
  Switch,
  InputNumber,
  upload,
} from "element-ui";
// import {
//   Button,
//   Form,
//   Message,
//   FormItem,
//   Input,
//   Container,
//   Header,
//   Aside,
//   Main,
//   Menu,
//   Submenu,
//   MenuItem,
//   Breadcrumb,
//   BreadcrumbItem,
//   Card,
//   Row,
//   Col,
//   Table,
//   TableColumn,
//   Switch,
//   Tooltip,
//   Pagination,
//   Dialog,
//   MessageBox,
//   Tag,
//   Tree,
//   Select,
//   Option,
//   Cascader,
//   Alert,
//   Tabs,
//   TabPane,
// } from "element-ui";
Vue.use(Button);
Vue.use(Form);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Row);
Vue.use(Col);
Vue.use(Pagination);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Card);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Tree);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(DescriptionsItem);
Vue.use(Descriptions);
Vue.use(Badge);
Vue.use(Cascader);
Vue.use(Tooltip);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Switch);
Vue.use(upload);
Vue.use(InputNumber);
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
